import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// utils

import { EndPoint } from '../../util/EndPoint';
//services

import { BaseService } from '../../util/BaseService';
import { RESTClientService } from '../../util/RESTClientService';
import { MensagemUtil } from '../../util/notificacao/mensagemUtil';
export class ConsultaPosService extends BaseService {
/**
 * @param {?} _restCliente
 * @param {?} mensagemUtil
 */
constructor(private _restCliente: RESTClientService,
private mensagemUtil: MensagemUtil) {
    super(mensagemUtil);
  }
/**
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @param {?} codigoEmpresa
 * @return {?}
 */
public getCombo(codigoInstituicao:number, rgmAluno:number, codigoEmpresa:number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaComboTurmaCombo(codigoInstituicao, rgmAluno, codigoEmpresa))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} rgmAluno
 * @param {?} codigoInstituicao
 * @param {?} codigoEmpresa
 * @param {?} codigoTurma
 * @return {?}
 */
public getDisciplinas(rgmAluno:number, codigoInstituicao:number,  codigoEmpresa:number, codigoTurma:number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaBoletimPos(rgmAluno, codigoInstituicao,  codigoEmpresa, codigoTurma) )
      .catch(error => this.handleError(error));
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RESTClientService, },
{type: MensagemUtil, },
];
}

function ConsultaPosService_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaPosService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaPosService.ctorParameters;
/** @type {?} */
ConsultaPosService.prototype._restCliente;
/** @type {?} */
ConsultaPosService.prototype.mensagemUtil;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
